<template>
    
<div>
    
    <transition name="fade">
<animated-loader v-if="loading"></animated-loader>

</transition>

       <masthead></masthead>
<div class="fish-footer"> 
    <div class="fish-container">
        

        <div class="fish-enter" >
   <router-link :to="{path:'/vr'}"> <div class="fish-box" >
        <p class="fish-heading">Enter VR</p>
        <p class="fish-subheading">Use headset</p></div></router-link>

                <router-link :to="{path: '/view'}">
            <div class="fish-box" >
        <p class="fish-heading">Enter 2D</p>
        <p class="fish-subheading">Use Chrome</p></div>
</router-link>


    </div>
        
        <div class="fish-icons">
            <div class="fish-info"><i class="small material-icons cyan-text text-accent-2" id="aboutIcon" v-on:click="showAbout=true">info</i></div>
            <div class="fish-sound"><i class="small material-icons cyan-text text-accent-2" id="soundIcon" v-on:click="soundButton">{{ifSound}}</i></div>
        </div>
    
    </div>
    </div>

  <transition name="fade">
<!-- reinstate to bring back password <access-page v-if="showAccess"></access-page>
 -->
<about v-if="showAbout" @clicked="showAbout=false"></about>
</transition>
</div>

</template>
<script>
    import About from '@/components/About'
    //reinstate to bring back password
    // import AccessPage from '@/components/Access'
    import Masthead from '@/components/Masthead'
    import AnimatedLoader from '@/components/AnimatedLoader'


    export default {
        name: 'splash',
         beforeMount: function() {
      this.loading = true
//reinstate to bring back password
//       if (this.access != "given") {
//         this.$router.push({name: 'access'})
// console.log("hello")
//       }
      
    },
    computed: {
   //reinstate to bring back password
    //   showAccess: function() { if (this.access === 'given') {
    //     return false
    //                 }
    //     else {
    //     return true
    //                 }
    // }
    },
        data() {
            return {
                loading: true,
                ifSound: 'volume_off',
                showAbout: false,
                message: null,
                buttonLabel: 'Submit'

               
            }
        },
    props: {
        access: String

    },

        methods: {

          
            
          curtainsUp: function() {
            this.loading = false

          },
            soundButton: function() {

                var theSound = document.getElementsByTagName('audio')[0];
 
                if (this.ifSound === 'volume_off') {
                    theSound.play();
                    this.ifSound = 'volume_up'

                }
                else {
                    theSound.pause();
                    this.ifSound = 'volume_off'

                }

            }
      
        },
        mounted: function() {
        


    var scene = document.querySelector('a-scene');
      if (scene.hasLoaded) {
        this.curtainsUp()
      }
      else {
        scene.addEventListener('loaded', this.curtainsUp)
      }  
        },
        
        components: {
            About, 

            //reinstate to bring back password
            //AccessPage,
            Masthead,
            AnimatedLoader
        }


    }
</script>

<style>



.fish-icons {
    clear: both;
}
.fish-box {
width: 50%;
float: left;
    padding: 6% 0;
    transition: 0.8s;
}

.fish-box:hover {
    background: blue;

}

.fish-heading {
font-size: 140%;
margin: 5px 0;
}

.fish-subheading {
font-size: 100%;
margin: 0;

}

   
        .fish-footer {
        font-family: 'Didact Gothic', sans-serif;
        z-index: 1000;
        color: #18ffff;
        width: 100%;
        position: absolute;
        bottom: 10%;
        
    }
    
    .fish-container {
        width: 70%;
        margin: 0 auto;
    }
.fish-enter {
            text-align: center;
            letter-spacing: 1px;
            margin: 0 auto;
}

.fish-enter a {    
color: inherit;
    }

.fish-info, .fish-sound{
  cursor: pointer;
}

.fish-info {
    float: left;
}
.fish-sound {
    text-align: right;
}

@media only screen and (min-width: 600px) {
.fish-enter {
            width: 50%;
}

}

@media only screen and (min-width: 801px) {
.fish-enter {
            width: 30%;
}

}

</style>
